import React, { useCallback, useEffect, useState } from 'react'
import db from '../../../resources/db';
import { IonPage, IonHeader, IonContent, IonToolbar, IonTitle, IonButtons, IonBackButton, IonRow, IonCol, IonList, IonItem, IonFabButton, IonIcon, IonModal, IonButton, useIonViewDidEnter, IonFooter, IonLabel, IonSelect, IonSelectOption, IonInput } from '@ionic/react';
import { toastController } from '@ionic/core'
import { trash, create } from 'ionicons/icons';
import UpdateStock from '../UpdateStock'
import { deleteAlert } from '../../../contexts/helperFn';
import jsonata from 'jsonata'
import { createToast } from '../../../resources/Hooks';
import moment from 'moment';
import MaterialTable from 'material-table';
import tableIcons from '../../../resources/tableIcons';

const StockItemDetail = ({ match, history }) => {
    let q = parseInt(match.params.id);

    const [StockItem, setStockItem] = useState({ log: [] })
    const [ShowModel, setShowModel] = useState(false);

    const [action, setAction] = useState(1);
    const [price, setPrice] = useState(0);
    const [quantity, setQuantity] = useState(0);
    const gstincludedPurchaseRate = jsonata('purchaseRate * (1 + gstRate/100)').evaluate(StockItem);

    const clearAll = () => {
        setAction(1);
        setPrice(0);
        setQuantity(0);
        setStockItem({ log: [] })
    }

    const loadData = useCallback(() => {
        let q = parseInt(match.params.id);
        db.stocks.get({ productId: q }).then(res => {
            setStockItem(updateStockItemData(res))
        })
    }, [match.params.id])

    useEffect(() => {
        loadData();
        return () => {
            clearAll();
        }
    }, [loadData]);


    updateStockItemData(StockItem);
    /** Add Product to Stocks */
    const deleteStock = () => {
        deleteAlert("Are you sure?", 'Are you sure you want to delete the record ?', () => {
            db.stocks.delete(q).then((res) => {
                console.log("Product Data Removed", res);
                toastController.create({
                    color: 'danger',
                    duration: 2000,
                    message: `Product '${q}' removed.`,
                    showCloseButton: true
                }).then(toast => {
                    toast.present();
                });
            });
            history.replace('/stocks');
        });
    }

    const updateAjustments = (e) => {
        let actiontype = ['Reduce Stock', 'Add Stock']
        e.preventDefault();
        console.log(action, price, quantity);

        if (quantity > 0) {
            let logentry = {
                id: Date.now(),
                to: '',
                date: moment().format('ll'),
                type: actiontype[action],
                quantity: quantity,
                rate: price,
                amount: price * quantity,
            }

            db.stocks.where("productName").equals(StockItem.productName).modify((value, ref) => {
                console.log(value, ref);
                // ref.value.log = []
                value.log.push(logentry);
            }).then(() => {
                console.log('Log entry updated');
                createToast('Stock Updated', 'success');
                loadData();
            })
        } else {
            createToast('Quantity must be greater than 0', 'danger');
        }
    }

    const AdjustStocks = () => (
        <div className="ion-padding">
            <h5>Adjust Stocks</h5>
            <form onSubmit={updateAjustments}>
                <IonRow>
                    <IonCol>
                        <IonItem>
                            <IonLabel position='floating'>Action</IonLabel>
                            <IonSelect interface='popover' value={action} onIonChange={e => setAction(e.detail.value)}>
                                <IonSelectOption value={1}>Add Stock</IonSelectOption>
                                <IonSelectOption value={0}>Reduce Stock</IonSelectOption>

                            </IonSelect>
                        </IonItem>
                    </IonCol>
                    <IonCol>
                        <IonItem>
                            <IonLabel position='floating'>Quantity</IonLabel>
                            <IonInput type='number' min='0' step='any' value={quantity} onIonInput={(e) => setQuantity(parseFloat(e.target.value))} />
                        </IonItem>
                    </IonCol>
                    <IonCol>
                        <IonItem>
                            <IonLabel position='floating'>Price</IonLabel>
                            <IonInput type="number" min='0' step='any' value={price} id='prate' onIonChange={(e) => setPrice(parseFloat(e.target.value))} />
                        </IonItem>
                    </IonCol>
                    <IonCol>
                        <IonButton color='danger' type='submit'>Adjust</IonButton>
                    </IonCol>
                </IonRow>
            </form>
        </div>
    )

    const LogTable = () => (
        <MaterialTable title="Log" options={{
            paging: false,
            search: false,
            toolbar: false,
            padding: 'dense',
            headerStyle: {
                backgroundColor: '#989aa2',
                color: '#FFF',
            }
        }} columns={[
            { title: 'Date', field: 'date', type: 'date', defaultSort: 'desc' },
            { title: 'Transaction Type', field: 'type' },
            { title: 'To', field: 'to' },
            { title: 'Quantity', field: 'quantity' },
            { title: 'Rate', field: 'rate', type: 'currency', currencySetting: { currencyCode: 'INR' } },
            { title: 'Amount', field: 'amount', type: 'currency', currencySetting: { currencyCode: 'INR' } },
        ]} data={StockItem.log} icons={tableIcons} />
    )

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonBackButton />
                    </IonButtons>
                    <IonTitle>Stock Detail - {StockItem.productName}</IonTitle>
                    <IonButtons slot='end'>
                        <IonButton shape='round' size='large' onClick={() => { setShowModel(true); }}>
                            <IonIcon icon={create}  >create</IonIcon>

                        </IonButton>
                        <IonButton shape='round' onClick={deleteStock}>
                            <IonIcon icon={trash} />
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className='ion-padding'>
                <h5>{StockItem.productName}</h5>

                <IonRow>
                    <IonCol>
                        <p>Purchase Rate : {(StockItem.purchaseRate)?.toFixed(2)}</p>
                        <p>Sale Rate : {(StockItem.rate)?.toFixed(2)}</p>
                        <p>GST Rate : {(StockItem.gstRate)?.toFixed(2)}%</p>
                    </IonCol>
                    <IonCol>
                        <p>Purchase Rate (GST Included) : {(gstincludedPurchaseRate)?.toFixed(2)}</p>
                        <p>Stocks Quantity : {StockItem.quantity}</p>
                        <p>Stocks Value : {(StockItem.stockValue)?.toFixed(2)}</p>
                    </IonCol>
                </IonRow>

                <LogTable />
                <IonModal isOpen={ShowModel} cssClass='stockupdate' onDidDismiss={() => setShowModel(false)} >
                    <UpdateStock data={{ setShowModel, StockItem, id: q }} />
                </IonModal>
            </IonContent>
            <IonFooter>
                {AdjustStocks()}
            </IonFooter>
        </IonPage>
    )
}

export const updateStockItemData = (StockItem) => {
    let subQuantity = 0;
    let stockValue = 0;

    if (StockItem.log.length) {

        let data = StockItem.log.map(item => {
            item.date = new Date(item.date);
            return item;
        })
        // brings quantity & rate of purchase data only
        let purchasePrice = jsonata("$[type='Purchase' or type='Opening Stock' or type='Add Stock'].rate").evaluate(data);
        let res = jsonata("$[type='Sales' or type='Reduce Stock'].quantity").evaluate(data);
        let salesQuantity = jsonata("$sum($)").evaluate(res)
        let purchaseQuantity = jsonata("$[type='Purchase' or type='Opening Stock' or type='Add Stock'].quantity").evaluate(data);
        // console.log(purchaseQuantity ,salesQuantity);
        // console.log(purchasePrice);
        let diff = 0;
        let sales_quantity = salesQuantity ? salesQuantity : 0;
        let purchase_quantity = [].concat(purchaseQuantity);
        let purchase_price = [].concat(purchasePrice);

        // if salesquantity is greater than purchasequantity then get diff and send it to next purchase quantity
        if (purchase_quantity) {
            for (let i = 0; i < purchase_quantity.length; i++) {
                const e = purchase_quantity[i]
                if (e > sales_quantity) {
                    purchase_quantity[i] -= sales_quantity;
                    sales_quantity = 0
                } else {
                    // console.log(pq[i] , sq);
                    diff = purchase_quantity[i] - sales_quantity
                    purchase_quantity[i] = 0;
                    sales_quantity = -diff
                }
                // console.log(pq[i] ,sq);
            }
        }
        // console.log(pq, pp);
        if (Array.isArray(purchase_quantity)) {
            stockValue = purchase_quantity.reduce(function (sum, a, i) {
                return sum + a * purchase_price[i]
            }, 0);
        } else {
            stockValue = parseFloat(purchaseQuantity * purchasePrice);
        }

        subQuantity = jsonata("$sum($)").evaluate(purchaseQuantity)

        subQuantity = StockItem.log.reduce((sum, product, i) => {
            let totalquantity = 0;
            const localType = ['Purchase', 'Opening Stock', 'Add Stock'];
            if (localType.includes(product.type)) {
                totalquantity = sum + product.quantity;
            } else {
                totalquantity = sum - product.quantity;
            }
            return totalquantity;
        }, 0);

        // console.log(subQuantity , stockValue);
        StockItem.quantity = parseFloat(subQuantity);
        StockItem.stockValue = stockValue ? parseFloat(stockValue) : 0;

        db.stocks.update(parseInt(StockItem.productId), { stockValue, quantity: subQuantity });

        return StockItem;
    }

}

export default StockItemDetail
